import React from "react";
import { isNullOrUndefined } from '../../../store/storeFunctions'
import { BarChart, Bar, ResponsiveContainer, CartesianGrid, XAxis, YAxis, LabelList } from 'recharts';

class CustomizedLabel extends React.Component {
    render() {
        const {
            x, y, width, value, height
        } = this.props;
        return (
            <text x={x + width / 2} y={y + 15} dy={-30} fill="black" textAnchor="middle" dominantBaseline="middle">
                {value.toFixed(1)}%
            </text>
        );
    }
};

class OpenChart extends React.Component {
    render() {
        let d = this.props.data;
        if (isNullOrUndefined(d) ||  d.openTotal === null || d.openTotal === 0 || (d.open30 === null && d.open60 === null && d.open90 === null && d.openOver90 === null)) {
            return null;
        }
        else {
            return (

                <div style={{ display: "flex", flexBasis: "100%", flexDirection: "column", minHeight: "500px" }}>
                    <h3 style={{ textAlign: "center", width: "100%", fontWeight: "600" }}>{this.props.header}</h3>
                    <ResponsiveContainer width="99%" height={400} style={{ padding: "2em" }}>
                        <BarChart data={this.prepareData(d)} margin={{ top: 20 }}>
                            <CartesianGrid strokeDasharray="0 3" />
                            <Bar isAnimationActive={false} dataKey="pct" fill="#003B79" >
                                <LabelList dataKey="pct" position="top" formatter={(value) => `${value.toFixed(1)}%`} />
                            </Bar>
                            <XAxis stroke="#8d949e" dataKey="name" label={{ value: this.props.xLabel, fontSize: "0.8em", dy: 10, fill: "#8d949e" }}></XAxis>
                            <YAxis stroke="#8d949e" dataKey="pct" type="number" label={{ value: this.props.yLabel, angle: -90, fontSize: "0.8em", dx: -10, fill: "#8d949e" }}></YAxis>
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            )
        }
    }
    prepareData(d) {
        let thirty = { name: "1-30", pct: (d.openTotal !== null && d.openTotal !== 0) ? d.open30 / d.openTotal * 100 : 0 };
        let sixty = { name: "31-60", pct: (d.openTotal !== null && d.openTotal !== 0) ? d.open60 / d.openTotal * 100 : 0 };
        let ninety = { name: "61-90", pct: (d.openTotal !== null && d.openTotal !== 0) ? d.open90 / d.openTotal * 100 : 0 };
        let overNinety = { name: "> 90", pct: (d.openTotal !== null && d.openTotal !== 0) ? d.openOver90 / d.openTotal * 100 : 0 };
        return [thirty, sixty, ninety, overNinety];
    }
}

class OpenChartCug extends React.Component {
    render() {
        let d = this.props.data;
        if (isNullOrUndefined(d) || d.openTotal === null || d.openTotal === 0 || (d.open30 === null && d.open60 === null && d.open90 === null && d.open120 === null)) {
            return null;
        } else {
            return (
                <div style={{ display: "flex", flexBasis: "100%", flexDirection: "column", minHeight: "500px" }}>
                    <h3 style={{ textAlign: "center", width: "100%", fontWeight: "600" }}>{this.props.header}</h3>
                    <ResponsiveContainer width="99%" height={400}>
                        <BarChart data={this.prepareData(d)} margin={{ top: 20 }}>
                            <CartesianGrid strokeDasharray="0 3" />
                            <Bar isAnimationActive={false} dataKey="pct" fill="#61b4e4">
                                <LabelList dataKey="pct" position="top" formatter={(value) => `${value.toFixed(1)}%`} />
                            </Bar>
                            <XAxis stroke="#8d949e" dataKey="name" label={{ value: this.props.xLabel, fontSize: "0.8em", dy: 10 }}></XAxis>
                            <YAxis stroke="#8d949e" dataKey="pct" type="number" label={{ value: this.props.yLabel, angle: -90, fontSize: "0.8em", dx: -28 }}></YAxis>
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            )
        }
    }
    prepareData(d) {
        let sixty = { name: "31-60", pct: (d.openTotal !== null && d.openTotal !== 0) ? d.open30 / d.openTotal * 100 : 0 };
        let ninety = { name: "61-90", pct: (d.openTotal !== null && d.openTotal !== 0) ? d.open60 / d.openTotal * 100 : 0 };
        let hundredTwenty = { name: "91-120", pct: (d.openTotal !== null && d.openTotal !== 0) ? d.open90 / d.openTotal * 100 : 0 };
        let overHundredTwenty = { name: "> 120", pct: (d.openTotal !== null && d.openTotal !== 0) ? d.open120 / d.openTotal * 100 : 0 };
        return [sixty, ninety, hundredTwenty, overHundredTwenty];
    }
}

export { OpenChart, OpenChartCug };